enum DialogStatus {
    Ok = 1,
    Cancel = 2,
    Close = 3,
    Destroy = 4,
    EmailVerified = 5,
    Unknown = 10,
}

export { DialogStatus };
